'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

export default function NimbalkarVadhuVar() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      {/* Transparent Header */}
      <Header variant="transparent" />

      <HomeHeroSection
        title="मराठा वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="nimbalkar_vadhu_var"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {[
                {
                  question: "What is Nimbalkar Maratha Vadhu Var?",
                  answer: "MarathaVadhuVarSuchak.com is the most trusted for Nimbalkar Maratha Vadhu Var Suchak in Maharashtra. You can download the MarathaVadhuVarSuchak.com mobile app for free registration."
                },
                {
                  question: "What is the category of Nimbalkar caste?",
                  answer: "Nimbalkars are ranked as Saptakuli Maratha, which is why they are in the general category. Nimbalkar belongs to Vashishta Gotra, and their clan goddess is Mata Tulja Bhavani, and Mahakaleshwar is their clan god."
                },
                {
                  question: "Which is the best Nimbalkar Maratha Vadhu Var Marriage bureau?",
                  answer: "The MarathaVadhuVarSuchak.com is the best Marriage bureau for Nimbalkar Vadhu Var."
                },
                {
                  question: "What is the Nimbalkar Maratha Vadhu Var Suchak Contact Number?",
                  answer: "Nimbalkar Maratha Vadhu Var can visit MarathaVadhuVarSuchak.com to get the contact number."
                },
                {
                  question: "How to search Nimbalkar Matrimony Vadhu Var Suchak profiles with photos?",
                  answer: "First visit MarathaVadhuVarSuchak.com to register for free. After profile approval, Nimbalkar Vadhu Var can search profiles with a photo."
                },
                {
                  question: "How to do Nimbalkar Vadhu Var Age-wise search?",
                  answer: "After free registration through MarathaVadhuVarSuchak.com, you can do Nimbalkar Vadhu Var Age-wise search."
                },
                {
                  question: "What do Nimbalkar Maratha Vadhu Var Suchak reviews say?",
                  answer: "MarathaVadhuVarSuchak.com reviews are positive with a 4 Plus rating."
                },
                {
                  question: "How to search Nimbalkar 96 Kuli Maratha Vadhu Var profiles?",
                  answer: "You can search Nimbalkar 96 Kuli Maratha Vadhu Var profiles on MarathaVadhuVarSuchak.com. However, registration is free on this Marathi matrimony site."
                },
                {
                  question: "Which is the best Satara Vadhu Var Suchak Mandal?",
                  answer: "Maratha Vadhu Var from the Satara region could register free on MarathaVadhuVarSuchak.com."
                },
                {
                  question: "Which is the best Marathi matrimony for Ingle Deshmukh Vadhu Var?",
                  answer: "The MarathaVadhuVarSuchak.com is the best Marathi matrimony for Ingle Deshmukh Vadhu Var in Maharashtra."
                },
                {
                  question: "Which is the best Nimbalkar Maratha Vadhu Var Suchak Pune?",
                  answer: "Nimbalkar Vadhu Var Suchak from Pune registers free through MarathaVadhuVarSuchak.com."
                }
              ].map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">
                      {faq.question}
                    </h3>
                    <svg
                      className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${
                        openFAQ === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div
                    className={`px-6 transition-all duration-300 ease-in-out ${
                      openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                    }`}
                  >
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Nimbalkar Vadhu Var Suchak for Maratha Community Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">
            What is Nimbalkar Maratha Community from Maharashtra?
            </h2>
            <p className="text-gray-700 leading-relaxed" style={{ fontSize: '1.11rem' }}>
            The Nimbalkar Maratha community is one of the distinguished and historically prominent clans within the 96 Kuli Maratha tradition of Maharashtra, known for their deep-rooted warrior heritage and noble lineage. The Nimbalkar family traces its origins to the Satara and Phaltan regions of Maharashtra, with ancestral ties to the glorious Maratha empire and the legacy of Chhatrapati Shivaji Maharaj. As a respected Maratha Kul, the Nimbalkar community upholds strong values of family honor, cultural traditions, gotra customs, and community bonding in every aspect of life including Marathi Vivah. Families within the Nimbalkar clan give great importance to matching Kul, gotra, and family background while seeking a suitable life partner for their son or daughter. At MarathiVadhuVarSuchak.com, we provide a dedicated matrimonial platform for Nimbalkar Maratha brides and grooms across Maharashtra and beyond. Register free today and find a verified Nimbalkar Maratha Vadhu or Var who truly matches your heritage, values, and family traditions.
            </p>
          </div>
        </div>
      </section>

    </div>
  );
}

